module.exports = __webpack_public_path__ + "img/Profile Icon 2.5d7f9738.svg";